import { createFileRoute } from '@tanstack/react-router'
import { ProveMobileComplete } from 'merchant-components'

export const Route = createFileRoute('/(public)/login/mobile/complete')({
  component: ProveMobileComplete,
})
